import { desktopBrowserSignInBridge } from './desktop-sign-in';
import { authClient } from '@/lib/better-auth-client-actions';

/** Where Google sends people back: the signing-in page, carrying the return target. */
export function signingInCallbackUrl(returnTo: string | null): string {
  return returnTo
    ? `/auth/signing-in?returnTo=${encodeURIComponent(returnTo)}`
    : '/auth/signing-in';
}

/**
 * Starts Google sign-in (or sign-up: Google creates the account when it is
 * new). On success the browser leaves for Google; the returned value is the
 * provider's error, or null.
 */
export async function startGoogleSignIn(args: {
  returnTo: string | null;
  locale: string;
  callbackURL?: string;
}): Promise<unknown> {
  const desktop = desktopBrowserSignInBridge();
  if (desktop) {
    try {
      await desktop.beginBrowserSignIn({
        returnTo: args.returnTo,
        callbackURL: args.callbackURL ?? signingInCallbackUrl(args.returnTo),
      });
      return null;
    } catch (error) {
      return error;
    }
  }
  const result = await authClient.signIn.social({
    provider: 'google',
    callbackURL: args.callbackURL ?? signingInCallbackUrl(args.returnTo),
    additionalData: { signupLocale: args.locale },
  });
  return result.error ?? null;
}
